import React from 'react';
import { images, profile } from '../content_helper';

const Blog = () => {
  return (
    <main className="pt-32 pb-stack-lg max-w-container-max mx-auto px-margin-page">
        {/*  Hero Section  */}
        <section className="mb-stack-lg border-l-4 border-primary pl-gutter">
            <h1 className="text-5xl md:text-6xl font-black mb-4 tracking-tight uppercase">ENGINEERING LOGS</h1>
            <p className="text-lg text-on-surface-variant max-w-2xl leading-relaxed">
                A technical deep dive into system architecture, local AI implementations, and enterprise-grade mobile
                development. Documenting the iterative process of high-performance engineering.
            </p>
        </section>
        {/*  Search & Filter Cluster  */}
        {/* <div className="flex flex-col md:flex-row justify-between items-center gap-stack-md mb-stack-md">
            <div className="w-full md:w-96 glass-card px-4 py-3 flex items-center gap-3 rounded-xl">
                <span className="material-symbols-outlined text-primary/70">search</span>
                <input
                    className="bg-transparent border-none focus:ring-0 text-sm w-full placeholder:text-on-surface-variant/50"
                    placeholder="Filter articles..." type="text" />
            </div>
            <div className="flex gap-2 overflow-x-auto pb-2 w-full md:w-auto">
                <span
                    className="px-4 py-1.5 bg-primary/20 text-primary font-semibold text-xs rounded-full border border-primary/30">All</span>
                <span
                    className="px-4 py-1.5 bg-surface-container-high/40 text-on-surface-variant font-medium text-xs rounded-full border border-outline-variant/30 hover:bg-surface-bright/40 cursor-pointer transition-colors">Infrastructure</span>
                <span
                    className="px-4 py-1.5 bg-surface-container-high/40 text-on-surface-variant font-medium text-xs rounded-full border border-outline-variant/30 hover:bg-surface-bright/40 cursor-pointer transition-colors">Mobile</span>
                <span
                    className="px-4 py-1.5 bg-surface-container-high/40 text-on-surface-variant font-medium text-xs rounded-full border border-outline-variant/30 hover:bg-surface-bright/40 cursor-pointer transition-colors">Machine
                    Learning</span>
            </div>
        </div> */}
        {/*  Featured Post - Bento Grid Style  */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-gutter mb-gutter">
            <article className="md:col-span-8 glass-card overflow-hidden group rounded-2xl">
                <div className="h-80 w-full relative">
                    <img
                        alt="Hybrid mobile architecture diagram"
                        className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 scale-105 group-hover:scale-100"
                        src="https://www.intellectsoft.net/blog/wp-content/uploads/Hybrid-Mobile-Architecture-1024x698.png" />
                    <div
                        className="absolute inset-0 bg-gradient-to-t from-surface-container-lowest via-transparent to-transparent opacity-80">
                    </div>
                    <div className="absolute top-6 left-6 flex gap-3">
                        <span
                            className="bg-primary text-on-primary px-3 py-1 text-xs font-bold tracking-widest uppercase rounded">FEATURED</span>
                        <span
                            className="bg-background/60 backdrop-blur-md border border-white/10 px-3 py-1 text-xs font-bold text-primary uppercase rounded">MOBILE
                            ARCHITECTURE</span>
                    </div>
                </div>
                <div className="p-gutter">
                    <div className="flex justify-between items-center mb-4">
                        <span className="text-xs font-bold text-secondary uppercase tracking-[0.2em]">March 14, 2024 • 12
                            Min Read</span>
                    </div>
                    <h2 className="text-3xl font-bold mb-4 group-hover:text-primary transition-colors leading-tight">Scaling
                        React Native for Government Platforms</h2>
                    <p className="text-on-surface-variant mb-6 leading-relaxed">
                        Exploring the unique challenges of implementing high-security, accessible, and offline-first
                        mobile applications using React Native for large-scale public sector initiatives.
                    </p>
                    <div className="flex gap-2 mb-6">
                        <span
                            className="bg-primary/10 text-primary border border-primary/20 text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded">React
                            Native</span>
                        <span
                            className="bg-primary/10 text-primary border border-primary/20 text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded">Security</span>
                        <span
                            className="bg-primary/10 text-primary border border-primary/20 text-[10px] font-bold uppercase tracking-widest px-2.5 py-1 rounded">Architecture</span>
                    </div>
                    <a className="inline-flex items-center gap-2 text-primary font-bold text-xs uppercase tracking-widest group/link"
                        href="/">
                        READ ARCHIVE <span
                            className="material-symbols-outlined group-hover/link:translate-x-2 transition-transform">arrow_right_alt</span>
                    </a>
                </div>
            </article>
            {/*  Sidebar Side Cards  */}
            <div className="md:col-span-4 flex flex-col gap-gutter">
                <article className="glass-card p-6 flex flex-col h-full border-t-4 border-t-primary rounded-2xl">
                    <span className="text-[10px] font-black text-secondary uppercase tracking-[0.3em] mb-3">Technical
                        Insight</span>
                    <h3 className="text-xl font-bold mb-4">The Cost of Performance</h3>
                    <p className="text-sm text-on-surface-variant flex-grow leading-relaxed">A quantitative analysis of
                        memory overhead in modern framework ecosystems and strategies for low-spec device optimization.
                    </p>
                    <div className="mt-6 pt-4 border-t border-white/5 flex justify-between items-center">
                        <span className="text-primary font-mono text-xs opacity-70">SystemDesign.log</span>
                        <span className="material-symbols-outlined text-primary/60 text-lg">analytics</span>
                    </div>
                </article>
                <article
                    className="glass-card p-6 flex flex-col h-full bg-primary/10 border-l-4 border-l-primary rounded-2xl">
                    <span className="text-[10px] font-black text-secondary uppercase tracking-[0.3em] mb-3">Quick
                        Byte</span>
                    <h3 className="text-xl font-bold mb-4">Zero Trust in Microservices</h3>
                    <p className="text-sm text-on-surface-variant flex-grow leading-relaxed">Implementing mTLS and service
                        mesh identity across distributed environments for hardened security posture.</p>
                    <div className="mt-6 pt-4 border-t border-white/5 flex justify-between items-center">
                        <span className="text-primary font-mono text-xs opacity-70">Network.security</span>
                        <span className="material-symbols-outlined text-primary/60 text-lg">security</span>
                    </div>
                </article>
            </div>
        </div>
        {/*  Journal Grid  */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-gutter">
            {/*  Article 2  */}
            <article className="glass-card group flex flex-col rounded-2xl overflow-hidden border border-white/10">
                <div className="code-header px-4 py-3 flex items-center justify-between">
                    <div className="flex gap-1.5">
                        <div className="w-2.5 h-2.5 rounded-full bg-error/60"></div>
                        <div className="w-2.5 h-2.5 rounded-full bg-primary/60"></div>
                        <div className="w-2.5 h-2.5 rounded-full bg-tertiary/60"></div>
                    </div>
                    <span
                        className="font-mono text-[10px] text-on-surface-variant/60 tracking-wider">ollama_deployment.sh</span>
                </div>
                <div className="p-gutter flex-grow">
                    <div className="flex gap-2 items-center mb-4">
                        <span className="text-[10px] font-bold text-secondary uppercase tracking-widest">February 28,
                            2024</span>
                        <span className="w-1 h-1 rounded-full bg-outline-variant"></span>
                        <span className="text-[10px] font-bold text-on-surface-variant/70 uppercase tracking-widest">8 Min
                            Read</span>
                    </div>
                    <h2 className="text-2xl font-bold mb-4 group-hover:text-primary transition-colors">Local LLMs with
                        Ollama</h2>
                    <p className="text-sm text-on-surface-variant mb-6 leading-relaxed">
                        Bridging the gap between cloud-based AI and local execution. A guide to deploying Llama 3 on
                        consumer hardware with GPU acceleration and private data isolation.
                    </p>
                    <div className="flex flex-wrap gap-2 mb-6">
                        <span
                            className="bg-surface-container-high/60 text-primary border border-white/5 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded">LLM</span>
                        <span
                            className="bg-surface-container-high/60 text-primary border border-white/5 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded">Ollama</span>
                        <span
                            className="bg-surface-container-high/60 text-primary border border-white/5 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded">Privacy</span>
                    </div>
                </div>
                <div className="p-gutter pt-0">
                    <div className="mt-4 pt-6 border-t border-white/5 flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <img className="w-10 h-10 rounded-full border-2 border-primary/30 object-cover"
                                alt={`Professional portrait of ${profile.name}`}
                                src={images.profile} />
                            <span className="text-xs font-bold text-on-surface uppercase tracking-widest">Dineshkumar
                                N.</span>
                        </div>
                        <button
                            className="text-primary hover:bg-primary/10 p-2 rounded-full transition-colors border border-primary/10">
                            <span className="material-symbols-outlined text-xl">bookmark</span>
                        </button>
                    </div>
                </div>
            </article>
            {/*  Article 3  */}
            <article className="glass-card group flex flex-col rounded-2xl overflow-hidden border border-white/10">
                <div className="code-header px-4 py-3 flex items-center justify-between">
                    <div className="flex gap-1.5">
                        <div className="w-2.5 h-2.5 rounded-full bg-error/60"></div>
                        <div className="w-2.5 h-2.5 rounded-full bg-primary/60"></div>
                        <div className="w-2.5 h-2.5 rounded-full bg-tertiary/60"></div>
                    </div>
                    <span
                        className="font-mono text-[10px] text-on-surface-variant/60 tracking-wider">rpi_cluster_node.md</span>
                </div>
                <div className="p-gutter flex-grow">
                    <div className="flex gap-2 items-center mb-4">
                        <span className="text-[10px] font-bold text-secondary uppercase tracking-widest">February 15,
                            2024</span>
                        <span className="w-1 h-1 rounded-full bg-outline-variant"></span>
                        <span className="text-[10px] font-bold text-on-surface-variant/70 uppercase tracking-widest">15 Min
                            Read</span>
                    </div>
                    <h2 className="text-2xl font-bold mb-4 group-hover:text-primary transition-colors">Raspberry Pi as
                        Production Server</h2>
                    <p className="text-sm text-on-surface-variant mb-6 leading-relaxed">
                        De-risking ARM-based edge computing. How we utilized Raspberry Pi 5 clusters for localized data
                        processing and persistent nodes in remote environments.
                    </p>
                    <div className="flex flex-wrap gap-2 mb-6">
                        <span
                            className="bg-surface-container-high/60 text-primary border border-white/5 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded">IoT</span>
                        <span
                            className="bg-surface-container-high/60 text-primary border border-white/5 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded">Hardware</span>
                        <span
                            className="bg-surface-container-high/60 text-primary border border-white/5 text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded">DevOps</span>
                    </div>
                </div>
                <div className="p-gutter pt-0">
                    <div className="mt-4 pt-6 border-t border-white/5 flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <img className="w-10 h-10 rounded-full border-2 border-primary/30 object-cover"
                                alt={`Professional portrait of ${profile.name}`}
                                src={images.profile} />
                            <span className="text-xs font-bold text-on-surface uppercase tracking-widest">Dineshkumar
                                N.</span>
                        </div>
                        <button
                            className="text-primary hover:bg-primary/10 p-2 rounded-full transition-colors border border-primary/10">
                            <span className="material-symbols-outlined text-xl">bookmark</span>
                        </button>
                    </div>
                </div>
            </article>
        </div>
        {/*  Newsletter Section  */}
        <section
            className="mt-stack-lg glass-card p-stack-md flex flex-col md:flex-row items-center justify-between gap-gutter rounded-3xl border-2 border-primary/20">
            <div className="max-w-lg">
                <h3 className="text-2xl font-black mb-3 text-gradient uppercase tracking-tight">Subscribe to Terminal
                    Updates</h3>
                <p className="text-sm text-on-surface-variant leading-relaxed">Get a bi-weekly notification about new
                    technical logs, architecture blueprints, and AI experiments directly to your inbox.</p>
            </div>
            <div className="flex w-full md:w-auto gap-3">
                <input
                    className="flex-grow md:w-72 bg-background/50 border border-white/10 focus:border-primary focus:ring-1 focus:ring-primary/30 text-sm px-5 py-3 rounded-xl backdrop-blur-sm"
                    placeholder="engineer@domain.com" type="email" />
                <a href="mailto:dineshnataraj345@outlook.com"
                    className="bg-primary text-on-primary font-bold text-xs uppercase tracking-widest px-8 py-3 rounded-xl whitespace-nowrap shadow-lg shadow-primary/20 hover:scale-105 transition-transform active:scale-95 flex items-center justify-center">Join
                    Stack</a>
            </div>
        </section>
    </main>
  );
};

export default Blog;
